import _ from 'lodash';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';
import withAnomalySchema from '../../hoc/withAnomalySchema';

import { getFileUploadTypes } from '../../../utils/utilities';
import { CoverDataItem, DamageClassItem } from '../../../utils/models';
import { FVI_SCHEMA } from '../../../utils/constants';

class AnomalyItemUTM extends Form {
	state = {
		data: {
			location: '',
			description: [],
			recommendation: [],
			class: '',
			generalImage: [],
			closeImage: [],
		},
		errors: {},
		loading: false,
		progress: 0,
		damageClasses: [],
	};

	schema = FVI_SCHEMA;

	static propTypes = {
		onAdd: PropTypes.func,
		damageClasses: PropTypes.array,
		options: PropTypes.array,
	};

	componentDidMount() {
		if (this.props.damageClasses) {
			this.setState({ damageClasses: this.props.damageClasses } as any);
		}
	}

	componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ data: any; errors: any; progress: number; loading: boolean; touched?: boolean; }>, snapshot?: any): void {
		if (!_.isEqual(this.schema, this.props.schema)) {
			this.schema = this.props.schema;
		}
	}

	doSubmit = (): void => {
		this.props.onAdd(this.state.data);

		this.setState({ 
			data: {
				location: '',
				description: [],
				recommendation: [],
				class: '',
				generalImage: [],
				closeImage: [],
			},
		});

		toastService.success('Anomaly Item Saved Successfully!');
	};

	mapAnomalyClasses = () => {
		return _.map(this.state.damageClasses, (item) => _.pick(item, ['id', 'name']))
	};

	getSelectedClassDescription = () => {
		const classMatch = _.find(this.state.damageClasses as DamageClassItem[], ['id', parseInt(this.state.data.class)]);
		if (classMatch) return classMatch.descriptions;

		return [];
	};
	
	getSelectedClassRecommendations = () => {
		const classMatch = _.find(this.state.damageClasses as DamageClassItem[], ['id', parseInt(this.state.data.class)]);
		if (classMatch) return classMatch.recommendations;

		return [];
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderSelect({
							options: this.props.options.map((option: CoverDataItem) => ({ id: option.value, name: option.label })),
							name: 'location',
							placeholder: 'Select Anomaly Location',
							label: 'Anomaly Location',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'class',
							placeholder: 'Select Class',
							label: 'Class',
							options: this.mapAnomalyClasses(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getSelectedClassDescription(),
							name: 'description',
							placeholder: 'Enter Anomaly Description',
							label: 'Anomaly Description',
							isMulti: true,
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getSelectedClassRecommendations(),
							name: 'recommendation',
							placeholder: 'Enter Remark & Recommendation',
							label: 'Remark & Recommendation',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: this.props.max,
							multiple: this.props.max > 1,
							hideCaption: true,
							name: 'generalImage',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image (General View)',
							sublabel: 'Upload photos showing general view',
							types: getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: this.props.max,
							multiple: this.props.max > 1,
							hideCaption: true,
							name: 'closeImage',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image (Close View)',
							sublabel: 'Upload photos showing close view',
							types: getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Add Anomaly Item')}
				</div>
			</form>
		);
	}
}

export default withAnomalySchema(AnomalyItemUTM);
